//#region src/space-access-version.ts
const SPACE_ACCESS_VERSION_HEADER = "x-openmeld-space-access-version";
const SPACE_ACCESS_VERSION = "2";
/** Preserve the fields understood by each strict shipped reader. */
function projectSpaceAccessViewForVersion(value, requestedVersion) {
	if (requestedVersion === "2") return value;
	if (requestedVersion === "1") return stripSpaceAccessFields(value, ["linkJoinPolicy"]);
	return projectLegacySpaceAccessView(value);
}
/** Older strict readers keep their original metadata/status shape. */
function projectLegacySpaceAccessView(value) {
	return stripSpaceAccessFields(value, [
		"ownerUserIds",
		"allowGuests",
		"linkJoinPolicy"
	]);
}
function stripSpaceAccessFields(value, fields) {
	if (!value || typeof value !== "object" || Array.isArray(value)) return value;
	const rest = { ...value };
	for (const field of fields) delete rest[field];
	return {
		...rest,
		...rest.meta === void 0 ? {} : { meta: stripSpaceAccessFields(rest.meta, fields) },
		...rest.status === void 0 ? {} : { status: stripSpaceAccessFields(rest.status, fields) }
	};
}
//#endregion
export { SPACE_ACCESS_VERSION, SPACE_ACCESS_VERSION_HEADER, projectLegacySpaceAccessView, projectSpaceAccessViewForVersion };

//# sourceMappingURL=space-access-version.js.map